export enum ClientTabs {
    CUSTOMER = 'Customer',
    CONTACT = 'Contact',
    PROJECTS = 'Projects',
    DISCOUNTS = 'Discounts',
}
